The details of the `CandidateProfile` that the `CandidateProcessHistoryItem` belongs to.
